export const ReceiptFragment = /* GraphQL */ `
	fragment ReceiptFragment on PrintLog {
		_id
		created_at
		updated_at
		payment_types {
			payment_type
			code
			amount
		}
	}
`;
